import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import FeesPayable from "./FeesPayable";
import MuqeemTable from "./MuqeemTable";
import EmployeeSalaryPackage from "./EmployeeSalaryPackage";
import LoadingWithLable from "../../../../../../ReusableComponents/Loading/LoadingWithLable";
import { axios } from "../../../../../../Global";
import { setAppError } from "../../../../../../store/userSlice";
import { useNavigate } from "react-router-dom";

const CostPlusCreate = ({ selectDatas, quotationId, updateCostSheetForm }) => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [COST_SHEET, SET_COST_SHEET] = useState([]);
  const [COST_SHEET_HEADING, SET_COST_SHEET_HEADING] = useState([]);
  const [FEES_PAYABLE, SET_FEES_PAYABLE] = useState([]);
  const [MUQEEM_POINTS, SET_MUQEEM_POINTS] = useState([]);

  const handleSubmit = (e) => {
    setSubmitLoading(true);
    e.preventDefault();
    const body = {
      cost_sheet_type: "costplus",
      quotation_id: quotationId,
      cost_sheet: COST_SHEET,
      cost_sheet_heading: COST_SHEET_HEADING,
      fees_payable: FEES_PAYABLE,
      muqeem_points: MUQEEM_POINTS,
    };
    
    axios
      .post(`dashboard/quotation-cost-sheet-module`, body, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        dispatch(
          setAppError({
            msg: res?.data?.message || "SUCCESSFULLY CREATED",
            color: "success",
          })
        );
        updateCostSheetForm((p) => ({
          open: false,
          method: "View",
        }));
        navigate(`/dashboard/quotation/${quotationId}`, {
          state: { method: "View", quotationId: quotationId },
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <EmployeeSalaryPackage
        selectDatas={selectDatas}
        SET_COST_SHEET={SET_COST_SHEET}
        SET_COST_SHEET_HEADING={SET_COST_SHEET_HEADING}
      />
      <FeesPayable SET_FEES_PAYABLE={SET_FEES_PAYABLE} />
      <MuqeemTable SET_MUQEEM_POINTS={SET_MUQEEM_POINTS} />
      <button
        type="submit"
        className="bg-red disabled:bg-rose-400 rounded-md p-2 px-4 w-full max-w-xs text-white absolute left-1/2 mt-10 cursor-pointer text-sm"
        disabled={submitLoading}
      >
        {submitLoading ? (
          <LoadingWithLable className={"!mt-0 text-white "} />
        ) : (
          `SUBMIT`
        )}
      </button>
    </form>
  );
};

export default CostPlusCreate;
